export interface IFilterStoreInterface {
  areaId: number
  startDate: null | Date
  endDate: null | Date
  rooms: null | Array<IRoom>
  accotypeIds: number[]
  themeId: number
  amenityIds: number[]
  boardingIds: number[]
  ratingFrom: number
  ratingTo: number
  companyIds: number[]
}

export interface IEnquiryDto {
  // general infos
  portalId: number
  language?: string
  enquiryType: number
  referer?: string
  track?: string // json string of tracking data
  ip?: string

  // travel details
  arrival?: string // iso date format
  departure?: string // iso date format
  rooms?: IRoom[]
  hasPets: boolean
  petsMessage?: string

  // contact details
  title: Title
  firstname?: string
  lastname?: string
  email?: string
  phone?: string
  message?: string
  privacy: boolean
  newsletter: boolean

  filter?: IEnquiryFilter

  companyIds?: number[]
  wishedOffers: number

  tag?: string
}

export interface IEnquiryFilter {
  areaIds?: number[]
  regionIds?: number[]
  themeIds?: number[]
  accotypes?: IAccotypeWithRatings[]
  amenityIds?: number[]
  boardingIds?: number[]
  excludeCompanyIds?: number[]
}

export interface IAccosFilter {
  areaId: number
  themeId: number
  accotypes?: IAccotypeWithRatings[]
  amenityIds?: number[]
  boardingIds?: number[]
  companyIds?: number[]
}

interface IAccotypeWithRatings {
  id: number
  ratingFrom: number
  ratingTo: number
}

export interface IEnquiryFormValues {
  date: string[]
  occupancy: IOccupancyForm
  title: Title
  firstname: string
  surname: string
  email: string
  phone: string
  message: string
  newsletter: boolean
  privacy: boolean
}
export interface IOccupancyForm {
  rooms: Array<IRoom>
  pets: { hasPets: boolean; message: string }
}

export enum Title {
  Unknown = 0,
  Herr = 1,
  Frau = 2,
  Familie = 3,
  Company = 4
}

export interface IOccupancyLocalStorage {
  location: ILocation
  date: string[]
  rooms: Array<IRoom>
  pets: { hasPets: boolean; message: string }
}

export interface ICountFilterStoreInterface {
  areaIds: number[]
  accotypes: IAccoId[]
  themeIds: number[]
  amenityIds: number[]
  boardingIds: number[]
  regionIds: number[]
  excludeCompanyIds: number[]
}

export interface IAccoId {
  id: number
  ratingFrom: number
  ratingTo: number
}

export interface IRoom {
  adults: number
  children: number
  childrenAges: Array<number | null>
}

export interface IFiltersDataInterface {
  accotypes: IAccotype[]
  themes: ITheme[]
  amenities: IAmenity[]
  boardings: IBoarding[]
  seed: ISeed
  privacyLink: string
}

export interface IAppliedFilters {
  appliedFilter: IAppliedFilter[]
}

export interface IAppliedFilter {
  id: string | number | Array<number>
  name: string
}

export interface IRegion {
  id: number
  name: string
}

interface IResort {
  id: number
  name: string
}

interface IAccotype {
  id: number
  name: string
  ratingFrom: number
  ratingTo: number
}

interface ITheme {
  id: number
  name: string
}

interface IAmenity {
  id: number
  name: string
  imagePath: string
}

export interface IBoarding {
  id: number
  name: string
}

interface ISeed {
  accosSeed: number
}

export interface IRoomDto {
  roomId: number
  supercompanyId: number

  roomtype: IRoomTypeDto

  hasDe: boolean
  hasIt: boolean
  hasEn: boolean

  nameDe: string
  nameIt: string
  nameEn: string
  descriptionDe: string
  descriptionIt: string
  descriptionEn: string
  size: string

  priceMin: number
  priceMax: number

  maxOccupancy: number
  minOccupancy: number
  defaultOccupancy: number

  priceAdditionalPersonDe: string
  priceAdditionalPersonIt: string
  priceAdditionalPersonEn: string

  assets: IRoomAssetsDto
}

export interface IRoomTypeDto {
  roomTypeId: number
  nameDe: string
  nameIt: string
  nameEn: string
}

export interface IRoomAssetsDto {
  gallery: any
  embeds: ReadonlyArray<IRoomEmbedDto>

  /** @deprecated Property will be removed! Use embeds property! */
  videos?: any

  /** @deprecated Property will be removed! Use embeds property! */
  interactiveMedia?: any
}

export interface IRoomEmbedDto {
  title: string
  description: string | undefined
  language: Language | undefined
  url: string
  thumbnail: any
  is360Grad: boolean
}

export enum Language {
  De = 1,
  It = 2,
  En = 3
}

export enum EnquiryBarOrigin {
  AccosUserList = 1,
  AccosListPage = 2
}

export interface IPackageDto {
  packageId: number
  uniqueId: string
  supercompanyId: number
  titleDe: string
  titleIt: string
  titleEn: string
  shortDescriptionDe: string
  shortDescriptionIt: string
  shortDescriptionEn: string
  urlDe: string
  urlIt: string
  urlEn: string
  bookUrlDe: string
  bookUrlIt: string
  bookUrlEn: string
  descriptionDe: string
  descriptionIt: string
  descriptionEn: string
  descriptionItemsDe: string[]
  descriptionItemsIt: string[]
  descriptionItemsEn: string[]
  startVisible: Date
  endVisible: Date
  earliestStart: Date
  latestEnd: Date
  themeId?: number
  specialistId?: number
  packageTypeId?: number
  themegroupId?: number
  position: number
  hasDe: boolean
  hasIt: boolean
  hasEn: boolean
  sort: number
  bookCode: string
  periods: IPackagePeriodDto[]
  images: any
}

export interface IPackagePeriodDto {
  packageperiodsId: number
  packageId: number
  start: Date
  end: Date
  nights: number
  minGuestApplicable: number
  breakfast: boolean
  lunch: boolean
  dinner: boolean
  allInklusive: boolean
  mon: boolean
  tue: boolean
  wed: boolean
  thu: boolean
  fri: boolean
  sat: boolean
  sun: boolean
  price: number
  descriptionItemsDe: string[]
  descriptionItemsIt: string[]
  descriptionItemsEn: string[]
  boarding: number
}

export interface IGuestDataStore {
  //properties need to be uppercase otherwise JsonSerializer.Deserialize<T>() of backend will not be able to parse it
  Arrival?: Date | string | null
  Departure?: Date | string | null
  Rooms?: Array<IRoom> | null
  HasPets: boolean
  PetsMessage?: string | null

  Title: Title
  Firstname?: string | null
  Lastname?: string | null
  Email?: string | null
  Phone?: string | null
  Message?: string | null
}

export interface ILocation {
  areaId: number
  name?: string
}

export enum EnquiryType {
  General = 1,
  Direct = 2,
  Collective = 3
}

export interface IPrimeVueLocale {
  emptySearchMessage: string
  firstDayOfWeek: number
  dayNames: string[]
  dayNamesShort: string[]
  dayNamesMin: string[]
  monthNames: string[]
  monthNamesShort: string[]
}
